
(function () {

    'use strict';
    angular.module('app')
        .service('forceSSOService',
            [
                '$http', function ($http) {

                    this.create = function(clientToken) {
                        return $http.post('api/forceSSO/create',
                            {
                                clientToken: clientToken
                            })
                            .then(function(response) {
                                    return response.data;
                                },
                                function(response) {
                                    throw (response.data);
                                });
                    };
                    
                }
            ]
        );
})();
